<!-- ChatToolbar.vue -->
<template>
	<div class="d-flex grey lighten-2 poppins-medium pa-2" style="height: 56px" v-if="!isLoadingConversationView">
		<!-- Back Button Section -->
		<div
			v-if="
			showBackButton &&
				isUserInRole('Nutritionist') &&
					$vuetify.breakpoint.xs &&
					currentConversationUserId
			"
			class="flex-grow-0 pr-2"
			style="padding-top: 6px"
		>
			<v-icon size="28" @click="handleBackClick">
				fas fa-arrow-circle-left
			</v-icon>
		</div>

		<!-- Title Section -->
		<div class="flex-grow-1 text-truncate">
			<!-- Nutritionist View -->

			<div
				v-if="isUserInRole('Nutritionist')"
				class="text-truncate pt-2 pr-2"
			>
				<span
					v-if="$vuetify.breakpoint.xs && CurrentConversationView"
					class="text-truncate d-inline-block"
					style="max-width: 100%"
				>
					{{ CurrentConversationView.DisplayName }}
				</span>
				<span
					v-else
					class="text-truncate d-inline-block"
					style="max-width: 100%"
				>
					{{ $t("pageTitle") }}
				</span>
			</div>

			<!-- Patient View -->
			<div
				v-if="isUserInRole('Patient') && CurrentConversationView"
				class="text-truncate"
			>
				<span
					v-if="$vuetify.breakpoint.xs"
					class="text-truncate d-inline-block"
					style="max-width: 100%"
				>
					<user-avatar-fullname
						class="d-inline-block"
						:showDisplayName="true"
						:profile="CurrentConversationView"
						:size="32"
					/>
					<v-icon
						class="d-inline"
						size="14"
						:color="
							CurrentConversationView.isOnline ? 'green' : 'grey'
						"
					>
						fas fa-circle
					</v-icon>
				</span>
				<v-toolbar-title v-else class="text-truncate">
					{{ $t("pageTitle") }}
				</v-toolbar-title>
			</div>
		</div>

		<!-- Actions Section -->
		<div class="flex-shrink-0 d-flex">
			<div
				v-if="isUserInRole('Nutritionist') && currentConversationUserId"
				class="d-flex"
			>
				<NutritionistListItemActions
					@conversationArchived="
						CurrentConversationView.IsArchived = 1
					"
					@conversationUnarchived="
						CurrentConversationView.IsArchived = 0
					"
					:Conversation="CurrentConversationView"
				/>
				<NutritionistBookingsList
					:Conversation="CurrentConversationView"
				/>

				<NutritionistRemindersActions
					class="mr-2"
					:UserId="currentConversationUserId"
					:key="currentConversationUserId"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import UserAvatarFullname from "@/components/Shared/UI/UserAvatarFullname.vue";
import NutritionistRemindersActions from "@/components/Chat/NutritionistRemindersActions.vue";
import NutritionistBookingsList from "@/components/Chat/NutritionistBookingsList";
import NutritionistListItemActions from "./NutritionistListItemActions";
import { mapGetters } from "vuex";

export default {
	name: "ChatToolbar",
	components: {
		UserAvatarFullname,
		NutritionistListItemActions,
		NutritionistBookingsList,
		NutritionistRemindersActions
	},
	props: {
		showBackButton: {
			default: true,
			type: Boolean
		}
	},
	computed: {
		...mapGetters([
			"CombinedConversationView",
			"isLoadingConversationView",
			"currentConversationUserId",
			"isUserInRole"
		]),

		CurrentConversationView() {
			if (this.currentConversationUserId) {
				return this.CombinedConversationView.find(
					c => c.UserId === this.currentConversationUserId
				);
			} else {
				return null;
			}
		}
	},
	methods: {
		handleBackClick() {
			this.$emit("reset-conversation");
		}
	}
};
</script>
<i18n>
{
	"it": {
		"pageTitle": "Messaggi",
		"chats": "Conversazioni"
	}
}
</i18n>
